import { FC } from "react";

import { ThemedFundraiser, ThemedFundraiserProps } from "./ThemedFundraiser";

export type ThemedGeneralFundraiserProps = Omit<ThemedFundraiserProps, "title" | "subtitle"> & {
  organizationName: string;
  campaignTitle: string;
};

export const ThemedGeneralFundraiser: FC<ThemedGeneralFundraiserProps> = ({
  organizationName,
  campaignTitle,
  ...rest
}) => {
  return <ThemedFundraiser {...rest} title={organizationName} subtitle={campaignTitle} />;
};
